import React, { useMemo, useState, useCallback } from 'react';
import MainLayout from '../layouts/MainLayout';
import ServiceCard from '../components/home/ServiceCard';
import HomeServiceModal from '../components/home/HomeServiceModal';
import {
  MarketplaceIcon,
  DatasetSearchIcon,
  WorkflowCreatorIcon,
  WorkflowEditorIcon,
  DataVisualizationIcon,
  MapVisualizationIcon,
  FileExplorerIcon,
  XrVrIcon,
} from '../components/icons/HomeServiceIcons';
import { useKeycloak } from '@react-keycloak/web';
import './HomeDashboard.css';

export const HOME_SERVICES = [
  {
    key: 'marketplace',
    title: 'Marketplace',
    description: 'Browse and acquire EO datasets and tools.',
    path: '/workspace/marketplace',
    icon: MarketplaceIcon,
  },
  {
    key: 'dataset-search',
    title: 'Dataset Search',
    description: 'Find specific satellite imagery and data.',
    path: '/workspace/dataset-search',
    icon: DatasetSearchIcon,
  },
  {
    key: 'workflow-creator',
    title: 'Workflow Creator',
    description: 'Design and automate data processing workflows.',
    path: '/workspace/workflow-creator',
    icon: WorkflowCreatorIcon,
  },
  {
    key: 'workflow-editor',
    title: 'Workflow Editor',
    description: 'Edit and run workflows in the visual editor.',
    path: '/workspace/workflow-editor',
    icon: WorkflowEditorIcon,
  },
  {
    key: 'data-visualization',
    title: 'Data Visualization',
    description: 'Visualize data in charts and graphs.',
    path: '/workspace/data-visualization',
    icon: DataVisualizationIcon,
  },
  {
    key: 'map-visualization',
    title: 'Map Visualization',
    description: 'Explore geospatial data on interactive maps.',
    path: '/workspace/map-visualization',
    icon: MapVisualizationIcon,
  },
  {
    key: 'file-explorer',
    title: 'File Explorer',
    description: 'Manage your stored files and datasets.',
    path: '/workspace/file-explorer',
    icon: FileExplorerIcon,
  },
  {
    key: 'xr-vr',
    title: 'XR/VR',
    description: 'Immersive data exploration experiences.',
    path: '/workspace/xr-vr',
    icon: XrVrIcon,
  },
];

function HomeDashboardView() {
  const [activeService, setActiveService] = useState(null);
  const { keycloak } = useKeycloak();

  const displayName = useMemo(() => {
    const t = keycloak?.tokenParsed || {};
    return (
      `${t.given_name || ''} ${t.family_name || ''}`.trim() ||
      t.name ||
      'there'
    );
  }, [keycloak?.tokenParsed]);

  const openService = useCallback((service) => {
    setActiveService(service);
  }, []);

  const closeService = useCallback(() => {
    setActiveService(null);
  }, []);

  return (
    <MainLayout menu='1'>
      <div className='home-dashboard'>
        <section className='home-hero' aria-label='Welcome'>
          <div className='home-hero__inner'>
            <h1 className='home-hero__title'>Welcome back, {displayName}!</h1>
            <p className='home-hero__subtitle'>
              Analyze the world through Earth Observation data and high-performance workflows.
            </p>
          </div>
          <div className='home-hero__bg' aria-hidden />
        </section>

        <div className='home-dashboard__grid'>
          {HOME_SERVICES.map((service) => (
            <ServiceCard
              key={service.key}
              title={service.title}
              description={service.description}
              icon={service.icon}
              onClick={() => openService(service)}
            />
          ))}
        </div>
      </div>

      <HomeServiceModal open={!!activeService} service={activeService} onClose={closeService} />
    </MainLayout>
  );
}

export default HomeDashboardView;
